module.exports = __webpack_public_path__ + "img/plus.c10012c6.svg";